import type { Quantity } from '@vista-digital/ocapi-types/v1'
import { createDomainStore, DomainStoreType } from '@vista-digital/occ-domain/src'

interface MemberRewardAvailabilityState {
    [showtimeId: string]: MemberRewardAvailability[]
}

export interface MemberRewardAvailability {
    rewardId: number
    ticketTypes: MemberRewardTicketType[]
}

interface MemberRewardTicketType {
    ticketTypeId: string
    isAvailable: boolean
    availableQuantity: Quantity
    unavailableMessage: string | null
}

export const memberRewardAvailabilityDomain = createDomainStore<MemberRewardAvailabilityState>({
    type: DomainStoreType.Memory,
    defaultState: {} as MemberRewardAvailabilityState,
})
